import React from 'react';
import { IconProps } from '.';

const SvgBeta = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 2.625)) || 24}
      fill='none'
      viewBox='0 0 63 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M9.932 1.75H2v20.28h8.782c2.174 0 3.813-.501 4.91-1.453 1.104-.957 1.623-2.337 1.623-4.01v-.685c0-1.423-.422-2.525-1.18-3.318-.564-.588-1.3-.99-2.153-1.234.76-.33 1.316-.8 1.704-1.362.524-.76.723-1.664.723-2.563v-.577c0-1.674-.528-2.964-1.636-3.825-1.096-.852-2.718-1.253-4.841-1.253ZM5.984 9.816V5.158h2.439c1.483 0 2.473.113 3.089.405.299.141.5.322.63.546.13.228.2.522.2.912v.493c0 .594-.092 1.018-.253 1.324-.158.3-.391.506-.71.65-.326.148-.743.232-1.262.277-.517.045-1.117.05-1.804.05H5.984Zm0 8.806V13.17h2.411c1.882 0 3.094.154 3.834.532.36.183.601.417.756.712.157.298.236.678.236 1.167v.604c0 .559-.088.975-.248 1.29-.159.31-.396.536-.73.705-.69.35-1.768.443-3.326.443H5.984Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M41.76 2.546h-3.956v3.868H35.39v3.353h2.414v7.734c0 1.436.27 2.637 1.032 3.477.766.845 1.98 1.272 3.745 1.272a8.258 8.258 0 0 0 3.2-.652l.184-.08-.647-3.267-.282.116c-.764.316-1.39.42-2.044.42-.44 0-.728-.07-.914-.235-.179-.16-.317-.463-.317-1.079V9.767h3.813V6.414h-3.813V2.546Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M54.612 6.085c-2.649 0-4.591.988-6.151 2.075l-.203.14 1.99 2.951.21-.165c1.222-.956 2.567-1.456 4.126-1.456.906 0 1.5.188 1.87.547.369.357.569.935.569 1.837v.326h-3.207c-2.157 0-3.652.465-4.61 1.288-.966.829-1.346 1.985-1.346 3.27v.877c0 1.395.498 2.526 1.442 3.303.936.773 2.282 1.172 3.938 1.172.83 0 1.797-.192 2.634-.56.553-.242 1.068-.568 1.446-.982l.04 1.323h3.592V11.163c0-1.6-.674-2.88-1.816-3.754C58 6.54 56.42 6.085 54.612 6.085Zm-2.905 11.114c0-.546.144-.945.455-1.214.319-.276.858-.456 1.736-.456h3.125v.161c0 1.145-.012 1.688-.554 2.206l-.004.004c-.648.648-1.531.942-2.95.942-.642 0-1.094-.138-1.38-.36-.278-.213-.428-.526-.428-.954V17.2ZM26.765 6.085c-1.965 0-3.753.547-5.053 1.75-1.303 1.206-2.083 3.042-2.083 5.55v1.564c0 2.759.878 4.599 2.24 5.744 1.353 1.138 3.147 1.557 4.924 1.557 2.865 0 4.837-.64 6.34-1.662l.191-.13-1.666-2.916-.218.127c-1.47.856-2.717 1.2-4.456 1.2-1.167 0-2.028-.298-2.597-.848-.526-.51-.836-1.266-.878-2.3h10.118v-2.747c0-2.262-.712-3.993-1.944-5.158-1.23-1.161-2.95-1.731-4.918-1.731Zm-3.262 6.203c0-.793.268-1.5.79-2.009.52-.508 1.316-.84 2.417-.84 1.159 0 1.923.334 2.4.825.478.494.697 1.179.697 1.942v.408h-6.304v-.326Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBeta;
